import { Alert }                from '@/components/ui/alert';
import { Button }               from "@/components/ui/button"
import { Field }                from '@/components/ui/field';
import { Grid }                 from '@chakra-ui/react';
import { GridItem }             from '@chakra-ui/react';
import { Input }                from '@chakra-ui/react';
import React                    from "react";
import { Text }                 from '@chakra-ui/react';
import UserResetPasswordModel   from '@/models/services/fondations/UserResetPasswordModel';
import { toaster }              from '@/components/ui/toaster';
import { useForm }              from 'react-hook-form';
import { useNavigate }          from 'react-router-dom';
import { useTranslation }       from 'react-i18next';
import useTranslations          from '@/hooks/useTranslations';

interface FormValues {
	email: string;
}

const ResetPasswordForm = () => {
	const { t } = useTranslation();
	const { getNavigationTranslation } = useTranslations();
	const navigate = useNavigate();
	const [displaySuccessMessage, setDisplaySuccessMessage] = React.useState(false);

	const {
		formState: { errors, isSubmitting },
		handleSubmit,
		register,
	} = useForm<FormValues>()

	const onSubmit = handleSubmit(async ({ email }) => {
		try {
			const resetPassword = new UserResetPasswordModel();
			await resetPassword.patch({
				email,
				routeUrl: location.origin + getNavigationTranslation('confirmationResetPassword', 'path'),
			});
			setDisplaySuccessMessage(true);
			
		} catch (error) {
			const newError = error as ErrorModel;
			const errorStatus = newError.connectorError.status;

			if (errorStatus === 400){
				toaster.create({
					title: t('pages.resetPassword.form.messages.alreadyAsked.title'),
					description: t('pages.resetPassword.form.messages.alreadyAsked.description'),
					type: 'error'
				})
			} else if (errorStatus === 404){
				toaster.create({
					title: t('pages.resetPassword.form.messages.notFound.title'),
					description: t('pages.resetPassword.form.messages.notFound.description'),
					type: 'warning',
					meta: { closable: true },
					duration: 5000,
				})
				navigate(`${getNavigationTranslation('registration', 'path')}?email=${encodeURIComponent(email)}`);
			} else {
				toaster.create({
					title: t('pages.resetPassword.form.messages.error.title'),
					description: t('pages.resetPassword.form.messages.error.description'),
					type: 'error'
				})
			}
			console.log(error);
		}
	});

	if (displaySuccessMessage) {
		return (
			<Alert status="warning" title={t('pages.resetPassword.form.messages.success.title')} >
				{t('pages.resetPassword.form.messages.success.description')}
			</Alert>
		)
	}

	return (
		<form onSubmit={onSubmit}>
			<Grid templateColumns="1fr" gap={5} >
				<GridItem>
					<Field
						label={<Text className="poppins-semibold" fontWeight="bold">{t('pages.resetPassword.form.inputs.email.label')}</Text>}
						required
					>
						<Input placeholder={t('pages.resetPassword.form.inputs.email.placeholder')}
							{
								...register(
									"email", 
									{
										required: true,
										pattern: {
											value: /\S+@\S+\.\S+/,
											message: t('pages.resetPassword.form.inputs.email.errors.pattern'),
										}
									}
								)
							}
						/>
						{errors.email?.type === 'required' && <Text color="red">{t('pages.resetPassword.form.inputs.email.errors.required')}</Text>}
						{errors.email?.type === 'pattern' && <Text color="red">{t('pages.resetPassword.form.inputs.email.errors.pattern')}</Text>}
					</Field>
				</GridItem>

				<GridItem>
					<Button 
						variant="solid" 
						type="submit" 
						width="100%"
						marginTop="20px"
						loading={isSubmitting}
					>
						{t('pages.resetPassword.form.actions.resetPassword')}
					</Button>
				</GridItem>
			</Grid>
		</form>
	);
};

export default ResetPasswordForm